<div role="dialog" aria-labelledby="modalAssistent" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalAssistent">
          {{ 'attendance.aiAssistant.configureTitle' | translate }}
          <br>
            <span class="text-muted fw-normal font-14">{{ 'attendance.aiAssistant.configureSubtitle' | translate }}</span>
          </h4>
          <button type="button" class="btn-close" [mat-dialog-close]="true" aria-hidden="true"></button>
        </div>
        <div class="modal-body custom-scroll-bar">
          <form [formGroup]="formGroup">
            <div class="w-100">
              <label class="form-label">{{ 'attendance.aiAssistant.aiAssistantsLabel' | translate }}</label>
              <mat-select
                class="form-control"
                formControlName="assistant"
                [placeholder]="'attendance.aiAssistant.select' | translate"
                (selectionChange)="onSelectAssistant($event)"
                >
                <mat-option [value]="null">{{ 'attendance.aiAssistant.none' | translate }}</mat-option>

                <!-- OpenAI Assistants -->
                @if (openaiIntegration) {
                  <mat-optgroup [label]="openaiIntegration.name">
                    @for (assistant of filteredAssistants; track assistant) {
                      <mat-option [value]="assistant.id">
                        {{ assistant.name }}
                      </mat-option>
                    }
                  </mat-optgroup>
                }

                <!-- GPT Maker Agents -->
                @if (gptMakerIntegration) {
                  <mat-optgroup [label]="gptMakerIntegration.name">
                    @for (agent of filteredAgents; track agent) {
                      <mat-option [value]="agent.id">
                        {{ agent.name }}
                      </mat-option>
                    }
                  </mat-optgroup>
                }
              </mat-select>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-light"
            (click)="cancel()">
            {{ 'attendance.aiAssistant.cancel' | translate }}
          </button>
          <button
            [disabled]="loading"
            class="btn btn-primary"
            (click)="confirm()"
            >
            {{ loading ? '' : ('attendance.aiAssistant.confirm' | translate) }}

            @if(loading) {
              <mat-spinner [diameter]="25" [color]="'accent'" mode="indeterminate" />
            }
          </button>
        </div>
      </div>
    </div>
  </div>

